export default __webpack_public_path__ + "static/media/1425.58ba7009.png";